export default __webpack_public_path__ + "static/media/web.a586e113.svg";